import { put, call, delay } from "redux-saga/effects";
import { POST, GET, PUT, DELETE } from "../../../../services/api";

export function* listLanguage(action) {
  yield put({ type: "LANGUAGE_SUCCESS", payload: action.payload["language"] });
}
